import React, { useCallback } from "react";
import ModalWrapper from "..";
import { Button } from "../../button";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useForceCheckOutVisitor } from "../../../hooks/visitor/mutation";
import { useForm } from "react-hook-form";

interface ForceCheckOutVisitorModalProps {
  checkInId: number;
  isOpen: boolean;
  onOpenChange: () => void;
}

const ForceCheckOutVisitorModal = ({
  checkInId,
  isOpen,
  onOpenChange,
}: ForceCheckOutVisitorModalProps) => {
  const { t } = useTranslation();

  const { handleSubmit } = useForm();

  const { mutateAsync: ForceCheckOutVisitor, isPending: isForceCheckOutVisitorLoading } =
    useForceCheckOutVisitor();

  const onSubmit = useCallback(
    async () => {
      if (!checkInId) return;
      
      try {
        const body = {
          EncryptedId: checkInId.toString(),
        };

        await ForceCheckOutVisitor(body);
        toast.success(t("visitorCheckedOutSuccessfully"));
      } catch (error) {
        toast.error(t("somethingWentWrong"));
      } finally {
        onOpenChange();
      }
    },
    [
      ForceCheckOutVisitor,
      t,
      onOpenChange,
    ]
  );

  return (
    <ModalWrapper isOpen={isOpen} onOpenChange={onOpenChange}>
      <form 
        onSubmit={handleSubmit(onSubmit)} 
        className="flex flex-col gap-8 justify-center items-center"
      >
        <p className="text-lg md:text-2xl font-medium">
          {t("areYouSureYouWantToForceCheckoutThisVisitor")}
        </p>

        <div className="flex gap-1 items-center">
          <Button
            isLoading={isForceCheckOutVisitorLoading}
            className=" bg-red-600 hover:bg-red-700"
          >
            {t("forceCheckOut")}
          </Button>

          <Button onClick={onOpenChange}>
            {t("close")}
          </Button>
        </div>
      </form>
    </ModalWrapper>
  );
};

export default React.memo(ForceCheckOutVisitorModal);
